export default __webpack_public_path__ + "static/media/12.e891afb2.jpg";